/**
 * Labstep
 *
 * @module components/ShareLink/Action/TogglePermissions
 * @desc Toggle view/edit permissions for ShareLink
 */

import { EntityUpdateContainer } from 'labstep-web/containers/Entity/Update';
import { PermissionMenu } from 'labstep-web/core/Permission';
import { PermissionType } from 'labstep-web/models/permission.model';
import {
  ShareLink,
  ShareLinkType,
} from 'labstep-web/models/share-link.model';
import type React from 'react';
import type { IToggleShareLinkPermissionProps } from './types';

export const ShareLinkActionTogglePermissions: React.FC<
  IToggleShareLinkPermissionProps
> = ({ shareLinkId }) => (
  <EntityUpdateContainer
    entityName={ShareLink.entityName}
    id={shareLinkId}
  >
    {({ update, entity: shareLink }) => (
      <PermissionMenu
        type={
          shareLink!.type === ShareLinkType.edit
            ? PermissionType.edit
            : PermissionType.view
        }
        onClick={update}
      />
    )}
  </EntityUpdateContainer>
);
